import { useUserInfo } from '@xolv-mybrightlink/common';
import { RootComponents } from '../pages/RootPage';

export const useResourcesMenuItems = (): RootComponents[] => {
  const userInfo = useUserInfo();
  const isEligibleToPilot = userInfo.hasPilotEligibleClient;

  if (isEligibleToPilot) {
    return [
      // CA-6505
      // RootComponents.Parent_Led_Curriculum
      RootComponents.Dimension_Parent_Class,
      RootComponents.Articles,
      RootComponents.Events,
    ];
  } else {
    return [
      RootComponents.Dimension_Parent_Class,
      RootComponents.Articles,
      RootComponents.Events,
    ];
  }
};
